import React, { useState, useRef, useEffect, useContext } from 'react';
import { useSnackbar } from '../../../context/SnackBarContext';
import {
  Typography,
  TextField,
  Box,
  Button,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import {
	Checkbox,
	FormControlLabel
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import FormServicio from '../servicio/ServicioDist.component';
import { UserContext } from './../../../context/UserContext';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Input,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { findBarras } from '../../../services/productosDist.service';
import Quagga from 'quagga';

const AccordionDetailsCustom = styled(AccordionDetails)`
  display: flex;
  justify-content: center;
`;

export default function RegistrarProducto({ datosOtg, setDatosOtg }) {
  const { showSnackbar } = useSnackbar();
  const handleClickSnackbar = (message, severity) => {
    showSnackbar({ message, severity });
  };

  const [productosVariantes, setProductosVariantes] = useState([]);
  const [mostrarEspere, setMostrarEspere] = useState(false);
  const [dropp, setDrop] = useState(false);
  const [variacionSeleccionada, setVariacionSeleccionada] = useState(null); // Estado para la variante seleccionada

  const scannerRef = useRef(null);
  const [isScanning, setIsScanning] = useState(false);

  // Función para obtener variantes por código de barras
  const getVariantesPorCodigoBarras = (cod_barras) => {
    setMostrarEspere(true);
    console.log('Buscando código de barras:', cod_barras);
    findBarras(cod_barras)
      .then((response) => {
        console.log('Response de API:', response);
        const nuevasVariantes = [];
  
        response.forEach((variante) => {
          const productoVariante = {
            id: variante.id_variacion,
            nombre_producto: variante.nombre_producto,
            talla: variante.Talla.nombre_talla,
            color: variante.Color.nombre_color,
            cod_barras: variante.cod_barras,
          };
  
          // Evitar duplicados por id
          const yaExiste = productosVariantes.some((p) => p.id === productoVariante.id);
          if (!yaExiste) {
            nuevasVariantes.push(productoVariante);
          }
        });
  
        // Acumular los nuevos productos sin sobrescribir los anteriores
        setProductosVariantes((prev) => [...prev, ...nuevasVariantes]);
        setMostrarEspere(false);
      })
      .catch(() => {
        setMostrarEspere(false);
        handleClickSnackbar('Producto no encontrado por código de barras.', 'error');
      });
  };

  // Iniciar o detener el escaneo
  const toggleScanner = () => {
    if (isScanning) {
      // Detener el escaneo
      Quagga.stop();
    } else {
      if (scannerRef.current) {
        Quagga.init(
          {
            inputStream: {
              type: 'LiveStream',
              constraints: {
                width: 640,
                height: 480,
                facingMode: 'environment',
              },
              target: scannerRef.current,
            },
            decoder: {
              readers: ['code_128_reader', 'ean_reader', 'ean_13_reader', 'upc_reader'],
            },
          },
          (err) => {
            if (err) {
              console.log('Error en la inicialización de Quagga:', err);
              return;
            }
            Quagga.start();
          }
        );

        // Evento cuando Quagga detecta un código
        Quagga.onDetected((data) => {
          const cod_barras = data.codeResult.code;
          console.log('Código detectado:', cod_barras);
          getVariantesPorCodigoBarras(cod_barras);  // Buscar producto por código detectado
        });
      } else {
        console.log('ScannerRef no está disponible');
      }
    }

    setIsScanning(!isScanning);
  };
  const datosSession = useContext(UserContext);

  // Configuración de columnas de la tabla
  const columns = [
    { field: 'nombre_producto', headerName: 'Producto', width: 400 },
    { field: 'talla', headerName: 'Talla' },
    { field: 'color', headerName: 'Color' },
    { field: 'cod_barras', headerName: 'Barras', width: 200 },
  ];

  // Usamos useEffect para iniciar el escaneo solo después de que el DOM haya sido completamente renderizado
  useEffect(() => {
    if (scannerRef.current && isScanning) {
      Quagga.init(
        {
          inputStream: {
            type: 'LiveStream',
            constraints: {
              width: 640,
              height: 480,
              facingMode: 'environment',
            },
            target: scannerRef.current,
          },
          decoder: {
            readers: ['code_128_reader', 'ean_reader', 'ean_13_reader', 'upc_reader'],
          },
        },
        (err) => {
          if (err) {
            console.log('Error en la inicialización de Quagga:', err);
            return;
          }
          Quagga.start();
        }
      );

      Quagga.onDetected((data) => {
        const cod_barras = data.codeResult.code;
        console.log('Código detectado:', cod_barras);
        getVariantesPorCodigoBarras(cod_barras);
      });
    }

    return () => {
      if (isScanning) {
        Quagga.stop();
      }
    };
  }, [isScanning]);

  // Manejar selección de producto
  const handleSeleccionarVariacion = (variacion) => {
    setVariacionSeleccionada(variacion);
    setDrop(true);
  
    setDatosOtg((prev) => ({
      ...prev,
      id_variacion: variacion.id,
      id_colaborador: datosSession.id_colaborador,
    }));
  };

  const handleRowSelection = (params) => {
    const selectedRow = params.row;
    handleSeleccionarVariacion(selectedRow);
  };

  return (
    <>
      

      {isScanning && (
        <Box sx={{ width: '100%', height: 400, border: '1px solid gray' }}>
          <div ref={scannerRef} style={{ width: '100%', height: '100%' }}></div>
        </Box>
      )}

      <TextField
        label="Código de Barras"
        fullWidth
        onChange={(e) => {
          getVariantesPorCodigoBarras(e.target.value);
        }}
      />

      <Box sx={{ height: 400, width: '100%' }}>
        <DataGrid 
          columns={columns} 
          rows={productosVariantes} 
          onRowClick={handleRowSelection} // Añadido para manejar la selección
        />
      </Box>

      <Accordion expanded={dropp}>
        <Grid container justifyContent="space-around" alignItems="center">
          <Typography variant="subtitle1">Producto seleccionado</Typography>
          <AccordionSummary expandIcon={<ExpandMore />} />
        </Grid>

        <AccordionDetailsCustom>
          {variacionSeleccionada && (
            <Grid item md={10}>
              <Grid container direction="row" justifyContent="space-between">
                <Typography variant="caption">Nombre:</Typography>
                <Typography variant="caption">{variacionSeleccionada.nombre_producto}</Typography>
              </Grid>

              <Grid container direction="row" justifyContent="space-between">
                <Typography variant="caption">Color:</Typography>
                <Typography variant="caption">{variacionSeleccionada.color}</Typography>
              </Grid>

              <Grid container direction="row" justifyContent="space-between">
                <Typography variant="caption">Talla:</Typography>
                <Typography variant="caption">{variacionSeleccionada.talla}</Typography>
              </Grid>

			  <Grid container direction="row" justifyContent="space-between">
                <Typography variant="caption">Código de Barras:</Typography>
                <Typography variant="caption">{variacionSeleccionada.cod_barras}</Typography>
              </Grid>
            </Grid>
          )}
        </AccordionDetailsCustom>

{/* INFORMACION DE LA OTG */}
<Accordion expanded={dropp}>
	<Grid container justifyContent='space-around' alignItems='center'>
		<Typography variant='subtitle1'>Información de la OTG</Typography>

		<AccordionSummary expandIcon={<ExpandMore />}></AccordionSummary>
	</Grid>

	<AccordionDetailsCustom>
		<Grid item md={10}>
		
			<Grid container justifyContent='space-between' sx={{ my: 2 }}>
				<Typography variant='caption'>
					Fecha de compra del producto:
				</Typography>

				<Input
					type='date'
					onChange={(e) => {
						setDatosOtg({
							...datosOtg,
							fecha_compra: e.target.value,
						});
					}}
					value={datosOtg.fecha_compra}
				/>
			</Grid>


      <Grid item xs={12}>
      

{datosOtg.imagen && (
  <Box mt={2}>
    <Typography>Imagen seleccionada: {datosOtg.imagen.name}</Typography>
    <img
      src={URL.createObjectURL(datosOtg.imagen)}
      alt='Vista previa'
      style={{ maxWidth: '100%', maxHeight: 200, marginTop: 10 }}
    />
  </Box>
)}
      </Grid>

			

			<TextField
				fullWidth
				label='Observaciones'
				name='observaciones'
				multiline
				placeholder='Ej. El producto tiene una descostura interna.'
				value={datosOtg.observaciones}
				onChange={(e) => {
					setDatosOtg({
						...datosOtg,
						observaciones: e.target.value,
					});
				}}
			/>
		</Grid>
	</AccordionDetailsCustom>
</Accordion>
{/* INFORMACION DEL SERVICIO */}
			<FormServicio
				dropAcordion={dropp}
				getServiciosFromComponent={(servicios) => {
					setDatosOtg({ ...datosOtg, servicios });
				}}
			></FormServicio>






      </Accordion>

<Accordion expanded={dropp}>
				<Grid container justifyContent='space-around' alignItems='center'>
					<Typography variant='subtitle1'>Información de la tienda</Typography>

					<AccordionSummary expandIcon={<ExpandMore />}></AccordionSummary>
				</Grid>

				<AccordionDetailsCustom>
					<Grid item md={10}>
						<Grid container justifyContent='space-around' alignItems={'center'}>
							<Typography>Usuario: {datosSession.usuario}</Typography>

							<TextField
								label='Responsable'
								name='responsable'
								value={datosOtg.responsable}
								onChange={(e) => {
									setDatosOtg({ ...datosOtg, responsable: e.target.value });
								}}
							/>
						</Grid>
					</Grid>
				</AccordionDetailsCustom>
			</Accordion>


    </>
  );
}
